<template>
    <div>
    	<div>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{ $t('RAM.AWS.database.multipleAZ') }}: </span>
                    <span class="expand-value">{{ row.multiAZ }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{ $t('RAM.AWS.database.runningStatus') }}: </span>
                    <span class="expand-value">{{ row.stateName }}</span>
                </Col>
            </Row>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{ $t('RAM.AWS.database.maintenance') }}: </span>
                    <span class="expand-value">{{ row.maintenance }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{ $t('RAM.AWS.database.launchTime') }}: </span>
                    <span class="expand-value">{{ row.databaseCreatedTime }}</span>
                </Col>
            </Row>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{ $t('RAM.AWS.database.subnetGroup') }}: </span>
                    <span class="expand-value">{{ row.subnetGroupName }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{ $t('RAM.AWS.database.backupPolicy') }}: </span>
                    <span class="expand-value">{{ row.backupPolice }}</span>
                </Col>
            </Row>
	        <Row class="expand-row">
	        	<Table :no-data-text="$t('common.noData')" :columns="columns" :data="subnetData" style="width: 100%;"></Table>
	        </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        },
        data () {
            return {
                columns: [ 
                {
                    title: this.$t('RAM.AWS.database.subnetID'),
                    key: 'subnetId',
                    render: (h,params) => {
                        return h('a',{
                            style: {
                                textDecoration: 'underline'
                            },
                            on: {
                                click: () => {
                                    this.$router.push({path: '/resourceConfigurationManagement/aws/subnetResource', query:{subnetIds:params.row.subnetId,type:"subnetId",t:Date.now()}})
                                }
                            }
                        },params.row.subnetId);
                    }
                },
                {
                    title: this.$t('RAM.AWS.database.region'),
                    key: 'region'
                }],
                subnetData:this.row.resourceSubnetList
            }
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/rds/TableExpand.vue